import React from "react";
import { signin, authenticate, isAuthenticated } from "../../auth";

const AdminProfile = () => {
  const name = isAuthenticated().user.name;
  return (
    <div>
      <h2>Welcome {name}</h2>
    </div>
  );
};

export default AdminProfile;
